/**
 * Testimonial cards: desktop hover crossfades video + text; mobile shows both lines.
 */
(function () {
  var mq = window.matchMedia("(max-width: 992px)");
  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  function hoverPosterFromDefault(poster) {
    if (!poster) return "";
    return poster.replace(/(\.[^./]+)$/, "-hover$1");
  }

  function ensureRelativeWrapper(el) {
    if (window.getComputedStyle(el).position === "static") {
      el.style.position = "relative";
    }
  }

  function playVideo(video) {
    if (!video) return;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {});
    }
  }

 /** Safari often ignores <video poster> until a frame is decoded; img overlay matches hero pattern. */
  function attachPosterLayer(video, posterSrc, modifierClass) {
    if (!video || !posterSrc) return null;

    var wrap = video.closest(".testimonial-card-img");
    if (!wrap) return null;

    video.setAttribute("poster", posterSrc);

    var poster = document.createElement("img");
  poster.className = "testimonial-card-poster" + (modifierClass ? " " + modifierClass : "");
    poster.src = posterSrc;
    poster.alt = "";
    poster.setAttribute("aria-hidden", "true");
    poster.decoding = "async";
    wrap.insertBefore(poster, video);

    function syncPosterVisibility() {
      if (video.readyState >= 2 && !video.paused && !video.ended) {
        poster.classList.add("is-hidden");
        return;
      }
      poster.classList.remove("is-hidden");
    }

    video.addEventListener("playing", syncPosterVisibility);
    video.addEventListener("pause", syncPosterVisibility);
    video.addEventListener("waiting", syncPosterVisibility);
    video.addEventListener("emptied", syncPosterVisibility);
    video.addEventListener("loadeddata", syncPosterVisibility);

    syncPosterVisibility();
    return poster;
  }



  document.querySelectorAll(".testimonial-cards").forEach(function (card) {
    var defaultVideo = card.querySelector(".testimonial-card-img video");
    var titleEl = card.querySelector(".testimonial-card-context h4");
    var hoverTextEl = card.querySelector(
      ".testimonial-card-context p.testimonial-card-hover-text"
    );
    var anchor = card.querySelector(".testimonial-card-context a");
    if (!defaultVideo || !titleEl || !hoverTextEl) return;

    var defaultText = card.getAttribute("data-default-text");
    var defaultVideoSrc = card.getAttribute("data-default-video");
    var hoverVideoSrc = card.getAttribute("data-hover-video");
    var hoverText = card.getAttribute("data-hover-text");
    var defaultPoster =
      card.getAttribute("data-default-poster") ||
      defaultVideo.getAttribute("poster") ||
      "";
    var hoverPoster =
      card.getAttribute("data-hover-poster") ||
      hoverPosterFromDefault(defaultPoster);

    if (defaultText) titleEl.textContent = defaultText;
    if (hoverText) hoverTextEl.textContent = hoverText;

    attachPosterLayer(
      defaultVideo,
      defaultPoster,
      "testimonial-card-poster--default"
    );

    if (mq.matches) {
      titleEl.classList.remove("d-none");
      hoverTextEl.classList.remove("d-none");
      if (anchor) anchor.classList.remove("d-none");
      return;
    }

    hoverTextEl.classList.remove("d-none");

    var imgWrap = defaultVideo.closest(".testimonial-card-img");
    var hoverVideoEl = null;

    if (hoverVideoSrc && hoverVideoSrc !== defaultVideoSrc) {
      defaultVideo.classList.add("testimonial-card-video--default");
      hoverVideoEl = defaultVideo.cloneNode(true);
      hoverVideoEl.classList.add("testimonial-card-video--hover");
      hoverVideoEl.removeAttribute("id");
      hoverVideoEl.removeAttribute("data-lazy-src");
      delete hoverVideoEl.dataset.lazyLoaded;

      var hoverSource = hoverVideoEl.querySelector("source");
      if (hoverSource) hoverSource.setAttribute("src", hoverVideoSrc);
      if (hoverSource) {
        hoverSource.setAttribute("src", hoverVideoSrc);
        hoverSource.removeAttribute("data-lazy-src");
      } else if (hoverVideoSrc) {
        hoverVideoEl.insertAdjacentHTML(
          "beforeend",
          '<source src="' + hoverVideoSrc + '" type="video/mp4">'
        );
      }
      if (hoverPoster) hoverVideoEl.setAttribute("poster", hoverPoster);

      hoverVideoEl.setAttribute("preload", "auto");
      hoverVideoEl.pause();
      hoverVideoEl.currentTime = 0;

      ensureRelativeWrapper(imgWrap);
      imgWrap.appendChild(hoverVideoEl);
      attachPosterLayer(
        hoverVideoEl,
        hoverPoster,
        "testimonial-card-poster--hover"
      );
      hoverVideoEl.load();
    }

    var transitionMs = prefersReducedMotion ? 0 : 450;

    function setHovered(hovered) {
      card.classList.toggle("is-hovered", hovered);

      if (!hoverVideoEl) return;

      window.clearTimeout(card._testimonialHoverTimer);

      if (hovered) {
        playVideo(hoverVideoEl);
        card._testimonialHoverTimer = window.setTimeout(function () {
          defaultVideo.pause();
        }, transitionMs);
        return;
      }

      playVideo(defaultVideo);
      card._testimonialHoverTimer = window.setTimeout(function () {
        hoverVideoEl.pause();
        hoverVideoEl.currentTime = 0;
      }, transitionMs);
    }

    card.addEventListener("mouseenter", function () {
      setHovered(true);
    });

    card.addEventListener("mouseleave", function () {
      setHovered(false);
    });
  });
})();